import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import '../Style/App.css';

export default function Home() {
  const params = new URLSearchParams(useLocation().search);
  const email  = params.get('email');

  return (
    <div className="loginPage">
      <img
        src="/GradyStar.png"
        alt="Logo"
        className="logo"
      />
      <div className="loginForm text-center">
        <h2><strong>Welcome Home!</strong></h2>
        <p style={{marginBottom: "15px", fontSize: "15px"}}>Your email <strong>{email}</strong> has been confirmed.</p>
        <Link to="/login" className="modern-btn">
          Proceed to Log In
        </Link>
      </div>
    </div>
  );
}
